// extracted by mini-css-extract-plugin
export default {"wrapper":"Team_wrapper__aKX1f","member_wrapper":"Team_member_wrapper__uZ5-j","item":"Team_item__K3ZnY"};